<template>
	<div class="content-contrainer">
		<div class="content-banner" :class="__lang"></div>
		<div class="content-menu-list">
			<div class="main-box">
				<router-link v-for="(item, index) in childrenMenu.child" :key="index" :to="item.link" class="content-menu-list-item" active-class="active">{{item.name}}</router-link>
			</div>
		</div>
		
		<div class="main-box">
			<el-row :gutter="50">
				<el-col class="childmenu-box" v-for="(item, index) in childrenMenu.child" :key="index" :span="12">
					<router-link class="childmenu-link" :to="item.link">
						<div style="width: 100%;height:360px;overflow: hidden;">
							<el-image
								class="thumb_img"
								:src="item.thumb_img"
								fit="cover"></el-image>
						</div>
						<span class="icon"></span>
						<p>{{item.name}}</p>
					</router-link>
				</el-col>
			</el-row>
		</div>
		
	</div>
</template>

<script>
import { navbar, researchData } from "../../data.js";
import lang from "../../lang.js";
export default {
	name: "research",
	data() {
		return {
			lang,
			researchData
		};
	},
	computed:{
		menus(){
		return navbar({
			lang:this.$route.params.lang || 'zh-CN'
		})
		},
		childrenMenu(){
			const menuList = this.menus.find(v=>v.id=="research");
			const thumbs = [
				require('../../assets/img/02kyzx_dashuju.png'),
				require('../../assets/img/02kyzx_zinengjias.png'),
				require('../../assets/img/02kyzx_rgzn.png'),
				require('../../assets/img/02kyzx_zngz.png')
			];
			/* const icons = [
				{
					default:require('../../assets/img/index_keyan_icon_dashuju.png'),
					active:require('../../assets/img/index_keyan_icon_dashujuh.png')
				},
				{
					default:require('../../assets/img/index_keyan_icon_jiashi.png'),
					active:require('../../assets/img/index_keyan_icon_jiashih.png')
				},
				{
					default:require('../../assets/img/index_keyan_icon_ganzhi.png'),
					active:require('../../assets/img/index_keyan_icon_ganzhih.png')
				},
				{
					default:require('../../assets/img/index_keyan_icon_shou.png'),
					active:require('../../assets/img/index_keyan_icon_shouh.png')
				}
			]; */
			menuList.child = menuList.child.map((v, i)=>{
				v.thumb_img = thumbs[i];
				return v;
			});
			return menuList;
		},
		__lang(){return this.$route.params.lang}
	}
};
</script>

<style lang="less">
.content-contrainer {
	padding-bottom: 60px;
}
.content-banner {
	margin-top: 70px;
	width: 100%;
	height: 340px;
	background: url(../../assets/img/banner_keyan.jpg) center center no-repeat;
  &.en {
    background: url(../../assets/img/banner_keyan_en.png) center center no-repeat;
  }
}
.content-menu-list {
	border-bottom: 1px solid #999;
	overflow: hidden;
	.content-menu-list-item {
		text-decoration: none;
		color: #222;
		float: left;
		line-height: 60px;
		font-size: 16px;
		padding: 0 19px;
		&.active{
			color: #d22c1d;
		}
		&.active:after {
			display: block;
			content: " ";
			width: 60%;
			height: 4px;
			background-color: #d22c1d;
			margin: auto;
		}
	}
}
.filed-desc {
	padding: 40px 0;
	line-height: 30px;
	font-size: 18px;
}
.labor-checkbox {
	margin-bottom: 40px;
	.labor-checkbox-btn {
		display:inline-block;
		line-height: 46px;
		height: 46px;
		padding: 0 30px;
		border-radius: 23px;
		background-color: #eee;
		margin-right: 40px;
		color: #222;
		text-decoration: none;
		&.active{
			color: #fff;
			background-color: #d22c1d;
		}
		&:last-child{
			margin-right: 0;
		}
	}
}
.childmenu-box {
	margin-top: 100px;
	text-align: center;
	font-size: 18px;
	position: relative;
	p {
		padding-bottom: 50px;
		margin-top: 50px;
		border-bottom: 1px solid #999;
	}
	.icon {
		display: block;
		position: absolute;
		width:120px;
		height:120px;
		top:100px;
		left: 50%;
		margin-left: -60px;
		border-radius: 60px;
		background:rgba(0,0,0,.6) url(../../assets/img/03dashuj.png) center no-repeat;
	}
	&:nth-child(2) .icon{
		background-image: url(../../assets/img/03jiashi.png);
	}
	&:nth-child(3) .icon{
		background-image: url(../../assets/img/03ai.png);
	}
	&:nth-child(4) .icon{
		background-image: url(../../assets/img/03ganzhi.png);
	}
	.thumb_img {
		width: 100%;
		transition: .6s;
	}
	&:hover {
		.thumb_img {
			transform: scale(1.1);
		}
	}
	.childmenu-link {
		text-decoration: none;
		color: #222;
	}
}
</style>
